module.exports = __webpack_public_path__ + "static/media/whitelogo.9f6f87ae.png";